<template>
    <div class="tw-max-w-screen-2xl tw-mx-auto tw-w-full tw-p-2 tw-pt-0 tw-flex tw-items-center tw-justify-center">
        
        <div class="tw-flex tw-items-center tw-gap-2">
            <div v-for="link in links" :key="link.key">
                <router-link 
                    v-if="!isExternalLink(link.route)"
                    :to="link.route"
                    :class="{'!tw-text-primary-600 tw-font-semibold': link.route.name == $route.name}"
                    class="tw-p-2 tw-text-primary-950 hover:tw-text-primary-600 tw-duration-200"
                >{{ getDisplayName(link) }}</router-link>
                <a 
                    v-else
                    :href="link.route"
                    :target="getTarget(link)"
                    :rel="getTarget(link) === '_blank' ? 'noopener noreferrer' : null"
                    class="tw-p-2 tw-text-primary-950 hover:tw-text-primary-600 tw-duration-200"
                >{{ getDisplayName(link) }}</a>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAuthStore } from '@/stores/auth';
import { getFilteredNavigationLinks, isExternalLink, getNavigationDisplayName, getNavigationTarget } from '@/config/navigation';

const authStore = useAuthStore();
const { t } = useI18n();
const user = computed(() => authStore.user);

// Filtered links based on user role
const links = computed(() => {
    return getFilteredNavigationLinks(user.value?.role);
});

// Get display name for navigation link
const getDisplayName = (link) => {
    return getNavigationDisplayName(link, t);
};

// Get target attribute for navigation link
const getTarget = (link) => {
    return getNavigationTarget(link);
};
</script>

